module.exports = __webpack_public_path__ + "static/img/ctimg72.ec67f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctimg72.png
// module id = ugli
// module chunks = 5